<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">热门话题管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="用户类型">
          <el-select v-model="formInline.role_name" clearable placeholder="请选择用户类型" >
            <el-option v-for="(item, index) in $store.state.posts" :key="index" :label="item.label"
              :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增话题</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="importUrl" :params="params" btnTitle="导入数据"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="type" label="分类" min-width="160">
      </custom-table-column>
      <custom-table-column prop="son_type" label="子分类" min-width="160">
      </custom-table-column>
      <custom-table-column prop="role_name" label="用户类型" min-width="140">
      </custom-table-column>
      <custom-table-column prop="question" label="问题" min-width="240">
      </custom-table-column>
      <custom-table-column prop="asking" label="回答" min-width="300">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleEditNew(scope.row, ['id'], () => {})" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="分类" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入，如：实验实训课程管理" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="子分类" prop="son_type">
          <el-input v-model="ruleForm.son_type" placeholder="请输入，如：项目审批" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="用户类型" prop="role_name">
          <el-select v-model="ruleForm.role_name" style="width:216px;" placeholder="请选择用户类型">
            <el-option v-for="(item,index) in $store.state.posts" :key="index" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题" prop="question">
          <el-input type="textarea" placeholder="请输入热门问题" :rows="4" v-model="ruleForm.question"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="回答" prop="asking">
          <el-input type="textarea" placeholder="请输入回答内容" :rows="6" v-model="ruleForm.asking"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  name: 'hotQuestions',
  mixins: [mixinList,mixinImport],
  data() {
    return {
      formInline: {
        role_name:''
      },
      ruleForm: {
        type: '',
        son_type: '',
        role_name: '',
        question: '',
        asking: ''
      },
      rules: {
        type: [{ required: true, message: '请输入分类', trigger: 'blur' }],
        son_type: [{ required: true, message: '请输入子分类', trigger: 'blur' }],
        role_name: [{ required: true, message: '请输入用户类型', trigger: 'blur' }],
        question: [{ required: true, message: '请输入问题', trigger: 'blur' }],
        asking: [{ required: true, message: '请输入回答', trigger: 'blur' }]
      },
      downloadUrl: 'template/热门话题导入模板.xlsx',
      importUrl: '',
    };
  },
  mounted() {
    this.$store.dispatch('getPosts');
    this.importUrl = `${this.baseUrlt}api/agent/hot/questions/import`;
  },
  methods: {
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/agent/hot/questions/totalList', 'get', params);
      if (res.code == 0 && res.data) {
        let list = res.data.data  || [];
        this.tableData = list;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/agent/hot/questions/insert', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！'
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/agent/hot/questions/save', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！'
        });
        this.clearState();
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/agent/hot/questions/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！'
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
